import { render, staticRenderFns } from "./MyIncidents.vue?vue&type=template&id=581dac90&scoped=true"
import script from "./MyIncidents.vue?vue&type=script&lang=js"
export * from "./MyIncidents.vue?vue&type=script&lang=js"
import style0 from "./MyIncidents.vue?vue&type=style&index=0&id=581dac90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581dac90",
  null
  
)

export default component.exports